import { jsx, Fragment } from 'react/jsx-runtime';
import StripeProvider from '../stripe-provider/StripeProvider.js';
var PaymentProvider = function PaymentProvider(_ref) {
  var amount = _ref.amount,
    paymentMethodType = _ref.paymentMethodType,
    isStubbed = _ref.isStubbed,
    renderLoadingIndicator = _ref.renderLoadingIndicator,
    renderPaymentButton = _ref.renderPaymentButton,
    stripeConfig = _ref.stripeConfig;
  var shouldRenderStripeProvider = isStubbed || (stripeConfig === null || stripeConfig === void 0 ? void 0 : stripeConfig.publishableKey) && (stripeConfig === null || stripeConfig === void 0 ? void 0 : stripeConfig.stripeAccount);
  return jsx(Fragment, {
    children: shouldRenderStripeProvider && jsx(StripeProvider, {
      amount: amount,
      isStubbed: isStubbed,
      paymentMethodType: paymentMethodType,
      renderLoadingIndicator: renderLoadingIndicator,
      renderPaymentButton: renderPaymentButton,
      stripeConfig: stripeConfig
    })
  });
};
export { PaymentProvider as default };